import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import ToggleButton from "react-toggle-button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync } from "../../../Services/Utils";
import { HttpStatus } from "../../common/Constants";
import MasterSopirDetail from "./components/masterSopirDetail";
import MasterSopirFilter from "./components/masterSopirFilter";
import { formGroup, initialPagination, tableConfig } from "./config";
import { constructPayloadSubmit } from "./utils";

class MasterSopir extends Component {
  iconPencil = (
    <i
      className="fa fa-lw fa-pencil-alt"
      style={{ color: "red", fontSize: 20 }}
    />
  );

  iconTrash = (
    <i className="fa fa-lw fa-trash" style={{ color: "red", fontSize: 20 }} />
  );

  tableColumns = [
    ...tableConfig,
    {
      name: "driverStatus",
      label: "Aksi",
      options: {
        customBodyRender: (val, { rowIndex }) => {
          const menuAccess = this.props.menuAccess[0]
          return (
            <FlexView style={{ gap: "10px" }}>
              <ToggleButton
                value={val === "ACTIVE"}
                onToggle={(value) =>
                  this.handleConfirmUpdateStatus(
                    this.state.dataTable[rowIndex],
                    value
                  )
                }
              />
              {menuAccess?.updateAccess && 
                <SimpleButton
                  category="action_button"
                  icon={this.iconPencil}
                  onClick={() =>
                    this.handleDetailVisibility(this.state.dataTable[rowIndex])
                  }
                />
              }
              {menuAccess?.deleteAccess &&
                <SimpleButton
                  category="action_button"
                  icon={this.iconTrash}
                  onClick={() =>
                    this.handleConfirmDelete(this.state.dataTable[rowIndex])
                  }
                />
              }
            </FlexView>
          );
        },
        sort: false,
      },
    },
  ];
  constructor(props) {
    super(props);
    this.state = {
      driverName: null,
      dataTable: [],
      loading: false,
      modalDetail: {
        visible: false,
        selectedData: null,
      },
      pagination: initialPagination,
      alertInfo: {
        type: null,
        content: null,
        visible: false,
        selectedData: null,
      },
      visibleFilter: false,
      skipNextPaginationFetch: false,
      submitedFilter: null,
    };
  }

  componentDidMount() {
    this.initialLoadData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currentState = this.state;
    const currentPagination = currentState.pagination;
    const prevPagination = prevState.pagination;

    const isPaginationChanged =
      prevPagination.page !== currentPagination.page ||
      prevPagination.limit !== currentPagination.limit;

    if (isPaginationChanged && !currentState.skipNextPaginationFetch) {
      (async () => {
        this.triggerLoading();
        const data = this.state.submitedFilter
        const payload = data?.driverStatus
           ? { ...data, driverStatus: data?.driverStatus?.value }
           : data;
        await this.fetchData(
          payload,
          currentPagination.limit,
          currentPagination.page
        );
        this.triggerLoading();
      })();
    }

    if (currentState.skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }
  }

  initialLoadData = async () => {
    this.triggerLoading();
    await this.fetchData()
    this.triggerLoading();
  }

  triggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  fetchData = async (filter = {}, limit, page) => {
    const result = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterSopirData,
      menuName: "Master Sopir - Data Table",
      setError: this.props.setError,
      args: {
        ...filter,
        limit: limit || this.state.pagination.limit,
        page: page || this.state.pagination.page,
      },
    });
    if (result.ok && result.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: result?.data?.data,
        pagination:{
          ...prev.pagination,
          totalData: result?.data?.totalData,
        }
      }));
    }
  };

  handleValueChange = ({ target }) => {
    const { value, name } = target;
    this.setState((prev) => ({
      [name]: value,
    }));
  };

  handleSearch = async () => {
    const { driverName } = this.state;
    this.triggerLoading();
    await this.fetchData(
      { driverName },
      this.state.pagination.limit,
      this.state.pagination.page
    );
    this.triggerLoading();
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleDetailVisibility = (index) => {
    this.setState((prev) => ({
      ...prev,
      modalDetail: {
        selectedData: index,
        visible: !prev.modalDetail.visible,
      },
    }));
  };

  handleResetPagination = (skip) => {
    this.setState((prev) => ({
      ...prev,
      pagination: initialPagination,
      skipNextPaginationFetch: skip,
    }));
  };

  handleRefetchAfterMutation = async () => {
    const data = this.state.submitedFilter
        const payload = data?.driverStatus
           ? { ...data, driverStatus: data?.driverStatus?.value }
           : data;
        this.fetchData(
          payload,
          this.state.pagination.limit,
          this.state.pagination.page
        );
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({ ...prev, visibleFilter: !prev.visibleFilter }));
  };

  handleConfirmSubmit = (value, isValid, originData) => {
    if (isValid) {
      this.handleAlertVisibility(
        "Pertanyaan",
        "Apakah anda yakin ingin menyimpan data ini ?",
        "save",
        { ...value, originData }
      );
      return;
    }
    this.handleAlertVisibility(
      "Peringatan",
      "Terdapat data yang belum lengkap, mohon periksa kembali"
    );
  };

  handleConfirmDelete = (value) => {
    if(value?.useInExpedisi){
      this.handleAlertVisibility(
        "Peringatan",
        "Data tidak dapat dihapus, karena terdapat nama sopir yang sudah di transaksikan",
        "delete",
        value.id
      );
      return
    }
    this.handleAlertVisibility(
      "Pertanyaan",
      "Apakah anda yakin ingin menghapus data ini ?",
      "delete",
      value.id
    );
  };

  handleConfirmUpdateStatus = (value, isShowAlert) => {
    if (isShowAlert) {
      this.handleAlertVisibility(
        "Pertanyaan",
        "Apakah anda yakin ingin menonaktifkan data ini ?",
        "updateStatus",
        value.id
      );
    } else {
      this.handleUpdateStatus(value.id, true);
    }
  };

  handleSubmit = async (data) => {
    this.triggerLoading();
    const { modalDetail } = this.state;
    const type = modalDetail.selectedData ? "EDIT" : "NEW";
    const payload = constructPayloadSubmit(type, data);
    const result = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").saveUpdateMasterSopir,
      menuName: `Master Sopir - ${type === "NEW" ? "Create" : "Edit"} Data`,
      setError: this.props.setError,
      args: payload,
    });
    await this.handleRefetchAfterMutation();
    this.triggerLoading();
    if (result.ok && result.data.status === HttpStatus.SUCCESS) {
      this.handleDetailVisibility();
      this.handleAlertVisibility("Informasi", "Data berhasil disimpan");
    }
  };

  handleDelete = async (id) => {
    this.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteSopirById,
      menuName: "Master Sopir - Hapus Sopir",
      setError: this.props.setError,
      args: id,
    });
    await this.handleRefetchAfterMutation();
    this.triggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleAlertVisibility("Informasi", "Data berhasil dihapus");
    }
  };

  handleUpdateStatus = async (id, isActivate) => {
    this.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusSopir,
      menuName: "Master Sopir - Update Status",
      setError: this.props.setError,
      args: id,
    });
    await this.handleRefetchAfterMutation();
    this.triggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const content = `Data Berhasil ${
        isActivate ? "Diaktifkan" : "Dinonaktifkan"
      }`;
      this.handleAlertVisibility("Informasi", content);
    }
  };

  handleSubmitFilter = async (data) => {
    this.triggerLoading();
    this.handleFilterVisibility();
    this.setState((prev) => ({
      ...prev,
      submitedFilter: data,
    }));
    // this.handleResetPagination(true);
    const payload = data.driverStatus
      ? { ...data, driverStatus: data?.driverStatus?.value }
      : data;
      
    await this.fetchData(
      payload,
      this.state.pagination.limit,
      this.state.pagination.page
    );
    this.triggerLoading();
  };

  handleAlertVisibility = (type, content, action, selectedData) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        type: type,
        content: content,
        action: action,
        selectedData: selectedData,
      },
    }));
  };

  handleAcceptAlert = async () => {
    const { alertInfo } = this.state;
    this.handleAlertVisibility();
    switch (alertInfo.action) {
      case "save":
        this.handleSubmit(alertInfo.selectedData);
        break;
      case "delete":
        this.handleDelete(alertInfo.selectedData);
        break;
      case "updateStatus":
        this.handleUpdateStatus(alertInfo.selectedData);
        break;

      default:
        break;
    }
  };

  render() {
    const {
      driverName,
      dataTable,
      pagination,
      loading,
      alertInfo,
      modalDetail,
      visibleFilter,
      submitedFilter,
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView
            style={{ justifyContent: "space-between" }}
            vAlignContent="center"
            className="margin-bottom-20px margin-top-5px"
          >
            <FlexView vAlignContent="center">
              <SimpleInput
                id="input_text_nama_sopir"
                placeholder="Nama Sopir..."
                name="driverName"
                containerclassname="margin-bottom-5px"
                value={driverName}
                onChange={this.handleValueChange}
              />
              <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
            </FlexView>
            <SimpleButton
              onClick={this.handleFilterVisibility}
              styles={{ width: "unset" }}
              icon={<i className={"fa fa-qrcode"}></i>}
            />
          </FlexView>
          <SimpleDataTable
            key={`${pagination.totalData}-${pagination.page}`}
            data={dataTable}
            columns={this.tableColumns}
            toCount={pagination.totalData}
            rowsPerPage={pagination.limit}
            page={pagination.page - 1}
            options={defaultTableChange(
              (tableState) => this.handleChangePage(tableState),
              (tableState) => this.handleRowsPerPage(tableState)
            )}
            footerAdditionalButtons={
              this.props.menuAccess?.[0]?.createAccess && (
                <SimpleButton
                icon={<i className="fa fa-plus margin-right-10px"></i>}
                  onClick={() => this.handleDetailVisibility()}
                >
                  Tambah
                </SimpleButton>
              )
            }
          />
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
        {modalDetail.visible && (
          <MasterSopirDetail
            {...this.props}
            formGroup={formGroup}
            selectedData={modalDetail.selectedData}
            visible={modalDetail.visible}
            handleTriggerLoading={this.triggerLoading}
            onClickClose={this.handleDetailVisibility}
            onSubmit={this.handleConfirmSubmit}
          />
        )}
        {visibleFilter && (
          <MasterSopirFilter
            visible={visibleFilter}
            submitedFilter={submitedFilter}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {alertInfo.visible && (
          <SimpleAlert
            visible={alertInfo.visible}
            title={alertInfo.type}
            content={alertInfo.content}
            onClickClose={this.handleAlertVisibility}
            additionalButtons={
              alertInfo.type === "Pertanyaan" ? (
                <FlexView>
                  <SimpleButton
                    type="button"
                    text="Tidak"
                    onClick={this.handleAlertVisibility}
                  />
                  <SimpleButton
                    type="button"
                    text="Ya"
                    onClick={this.handleAcceptAlert}
                  />
                </FlexView>
              ) : (
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={this.handleAlertVisibility}
                />
              )
            }
          />
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterSopir);
